import React from 'react'
import moment from 'moment/moment'
import { ErrorGroupChangelogEntry } from '../../domain/Error'
import { Alert } from '../../ui/alert'

interface Props {
    entries: ErrorGroupChangelogEntry[]
}

export class ErrorGroupChangelog extends React.Component<Props> {
    public render() {
        if (this.props.entries.length === 0) {
            return (
                <div className="box box-default" style={{ marginBottom: 0, paddingLeft: 10 }}>
                    <div className="box-body">
                        <Alert key="alert" level="info" additionalClasses="tw-ml-8">
                            No changes recorded. <br />
                            Data is only available after December 16th, 2025
                        </Alert>
                    </div>
                </div>
            )
        }

        return [
            <table key="table" className="table table-striped">
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>User</th>
                        <th>Message</th>
                    </tr>
                </thead>
                <tbody>
                    {this.props.entries.map((changelog, index) => (
                        <tr key={index}>
                            <td>
                                {moment
                                    .utc(changelog.createdAt)
                                    .local()
                                    .format('DD.MM.YY HH:mm')}
                            </td>
                            <td>{changelog.username || '-'}</td>
                            <td>{changelog.message}</td>
                        </tr>
                    ))}
                </tbody>
            </table>,
            <Alert key="alert" level="info" compact>
                Data is only available after December 16th, 2025
            </Alert>,
        ]
    }
}
